'use strict'

;(function exposeSiteProtection (globalScope, factory) {
  const api = factory()

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api
  }

  if (globalScope) {
    globalScope.UniverseSiteProtection = api
  }
})(typeof window !== 'undefined' ? window : null, function createSiteProtection () {
  const MEDIA_STYLE_ID = 'universe-site-media-protection'
  const MEDIA_SELECTOR = 'img, picture, svg, canvas, video'
  const DEVELOPER_KEYS = ['c', 'i', 'j', 'k']

  function eventKey (event) {
    return String(event && event.key ? event.key : '').toLowerCase()
  }

  function isBlockedDeveloperShortcut (event) {
    if (!event) return false

    const key = eventKey(event)
    const keyCode = Number(event.keyCode || event.which || 0)
    if (key === 'f12' || keyCode === 123) return true

    const windowsOrLinuxViewSource = event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey && key === 'u'
    const macViewSource = event.metaKey && event.altKey && !event.ctrlKey && !event.shiftKey && key === 'u'
    if (windowsOrLinuxViewSource || macViewSource) return true

    const windowsOrLinuxShortcut = event.ctrlKey && event.shiftKey && !event.metaKey && !event.altKey && DEVELOPER_KEYS.indexOf(key) >= 0
    const macShortcut = event.metaKey && event.altKey && !event.ctrlKey && !event.shiftKey && DEVELOPER_KEYS.indexOf(key) >= 0
    return Boolean(windowsOrLinuxShortcut || macShortcut)
  }

  function resolveDocument (root) {
    if (!root) return null
    if (root.nodeType === 9) return root
    return root.ownerDocument || null
  }

  function installMediaStyles (root) {
    const documentRoot = resolveDocument(root)
    if (!documentRoot || typeof documentRoot.createElement !== 'function') return
    if (documentRoot.getElementById && documentRoot.getElementById(MEDIA_STYLE_ID)) return

    const parent = documentRoot.head || documentRoot.documentElement
    if (!parent || typeof parent.appendChild !== 'function') return

    const style = documentRoot.createElement('style')
    style.id = MEDIA_STYLE_ID
    style.textContent = [
      'img, picture, svg, canvas, video {',
      '  -webkit-touch-callout: none !important;',
      '  -webkit-user-drag: none !important;',
      '  user-drag: none !important;',
      '  -webkit-user-select: none !important;',
      '  user-select: none !important;',
      '}'
    ].join('\n')
    parent.appendChild(style)
  }

  function cancelEvent (event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault()
  }

  function isProtectedMediaDrag (event) {
    const eventTarget = event && event.target
    const target = eventTarget && eventTarget.nodeType === 1 ? eventTarget : eventTarget && eventTarget.parentElement
    if (!target || typeof target.closest !== 'function') return false

    const draggableControl = target.closest('[draggable="true"]')
    const media = target.closest(MEDIA_SELECTOR)
    if (!media) return false
    if (!draggableControl || typeof draggableControl.matches !== 'function') return true
    return draggableControl.matches(MEDIA_SELECTOR)
  }

  function cancelProtectedMediaDrag (event) {
    if (isProtectedMediaDrag(event)) cancelEvent(event)
  }

  function stopBlockedShortcut (event) {
    if (!isBlockedDeveloperShortcut(event)) return
    cancelEvent(event)
    if (typeof event.stopPropagation === 'function') event.stopPropagation()
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation()
  }

  function installSiteProtection (root) {
    if (!root || typeof root.addEventListener !== 'function') return () => {}

    let installed = true
    root.addEventListener('contextmenu', cancelEvent, true)
    root.addEventListener('dragstart', cancelProtectedMediaDrag, true)
    root.addEventListener('keydown', stopBlockedShortcut, true)
    installMediaStyles(root)

    return () => {
      if (!installed) return
      installed = false
      root.removeEventListener('contextmenu', cancelEvent, true)
      root.removeEventListener('dragstart', cancelProtectedMediaDrag, true)
      root.removeEventListener('keydown', stopBlockedShortcut, true)
    }
  }

  return {
    installSiteProtection,
    isBlockedDeveloperShortcut,
    isProtectedMediaDrag
  }
})



// WEBPACK FOOTER //
// ./src/lib/siteProtection.js